export enum DocumentType {
  SOCIETY = 'society',
  BOARD = 'board',
}
